<template>
  <div class="col-md-2" style="position: static">
    <div class="customer-timeline-pinned-event d-flex align-items-start justify-content-start"
      :class="{ expanded: expanded }" @click="$emit('expand', event, entity)">
      <div class="customer-timeline-pinned-event__icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
          <g clip-path="url(#clip0_272_1148)">
            <path
              d="M12.9941 6.35625C12.7995 6.61985 12.513 6.80068 12.1913 6.86284C11.8696 6.92501 11.5363 6.86397 11.2576 6.69185C11.1044 6.5905 11.1044 6.59275 10.9355 6.76391C10.1089 7.60175 9.88143 7.82698 9.19223 8.50942L8.88367 8.81798C8.83474 8.86293 8.82636 8.86133 8.8634 8.91259C9.74179 10.2347 9.18322 11.7167 8.36565 12.6626C7.95017 13.1092 7.51857 13.1165 7.08185 12.7144C6.3225 11.9527 5.76242 11.4097 4.93769 10.5613C4.85902 10.4927 4.89284 10.48 4.78679 10.5613C4.13814 11.0928 3.48798 11.6213 2.83632 12.1468C2.44443 12.4644 2.05103 12.7827 1.65613 13.1018C1.53477 13.2186 1.37603 13.2888 1.20793 13.3C1.14231 13.2987 1.07761 13.2843 1.01766 13.2576C0.957696 13.2309 0.903692 13.1925 0.85883 13.1446C0.543512 12.836 0.777748 12.514 0.8791 12.3766C1.68932 11.2664 2.47939 10.1604 3.30705 9.05223C3.36698 8.96857 3.35723 8.98939 3.28453 8.91259C2.53706 8.17159 2.01868 7.6519 1.34757 6.97789C0.872186 6.5066 0.899499 6.03038 1.40613 5.59049C2.35659 4.76166 3.98498 4.32922 5.12463 5.16031C5.13364 5.16707 5.1404 5.17157 5.14715 5.17607C6.12879 4.18425 6.54831 3.76528 7.40618 2.9148C7.20004 2.63179 7.10794 2.28158 7.14819 1.93379C7.18844 1.58599 7.35809 1.26607 7.62342 1.03763C7.88874 0.809184 8.23032 0.688946 8.58023 0.700815C8.93015 0.712683 9.26279 0.855789 9.51203 1.10168C10.922 2.49811 11.5256 3.10397 12.9197 4.5094C13.1586 4.75338 13.2985 5.07733 13.3122 5.41852C13.326 5.75971 13.2126 6.09386 12.9941 6.35625Z"
              fill="white" />
          </g>
          <defs>
            <clipPath id="clip0_272_1148">
              <rect width="14" height="14" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div class="customer-timeline-pinned-event__title">
        {{ event_title }}<br>
        {{ event_subtitle }}
      </div>
    </div>
    <transition name="fade">
      <div v-if="expanded" class="customer-timeline-pinned-event__detail container-fluid">

        <div class="row">
          <div class="col-md-6 d-flex align-items-center">
            <a class="customer-timeline-pinned-event__detail-title" @click="editEvent"
              :class="{ editable: is_editable }">
              {{ event_detail_title }}
              <i v-if="is_editable" class="fas fa-edit"></i>
            </a>
          </div>
          <div class="col-md-6 d-flex align-items-center justify-content-end">
            <div class="customer-timeline-pinned-event__doctor mx-3">
              {{ event_doctor }}
            </div>
            <div class="customer-timeline-pinned-event__date mx-3">
              {{ event_date }}
            </div>
            <div v-if="!event.unpinnable" class="customer-timeline-pinned-event__pin-icon mx-3"
              :class="{ pinned: is_pinned }" @click="pinEvent">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <g clip-path="url(#clip0_220_194)">
                  <path
                    d="M12.9941 6.35625C12.7996 6.61985 12.513 6.80068 12.1914 6.86284C11.8697 6.92501 11.5364 6.86397 11.2576 6.69185C11.1045 6.5905 11.1045 6.59275 10.9356 6.76391C10.109 7.60175 9.88149 7.82698 9.19229 8.50942L8.88373 8.81798C8.83481 8.86293 8.82642 8.86133 8.86346 8.91259C9.74185 10.2347 9.18328 11.7167 8.36571 12.6626C7.95023 13.1092 7.51863 13.1165 7.08191 12.7144C6.32256 11.9527 5.76249 11.4097 4.93775 10.5613C4.85909 10.4927 4.8929 10.48 4.78685 10.5613C4.1382 11.0928 3.48804 11.6213 2.83638 12.1468C2.44449 12.4644 2.05109 12.7827 1.65619 13.1018C1.53483 13.2186 1.37609 13.2888 1.20799 13.3C1.14237 13.2987 1.07768 13.2843 1.01772 13.2576C0.957757 13.2309 0.903753 13.1925 0.858891 13.1446C0.543573 12.836 0.777809 12.514 0.879161 12.3766C1.68938 11.2664 2.47945 10.1604 3.30711 9.05223C3.36704 8.96857 3.35729 8.98939 3.28459 8.91259C2.53713 8.17159 2.01874 7.6519 1.34763 6.97789C0.872247 6.5066 0.89956 6.03038 1.40619 5.59049C2.35665 4.76166 3.98504 4.32922 5.12469 5.16031C5.1337 5.16707 5.14046 5.17157 5.14721 5.17607C6.12885 4.18425 6.54837 3.76528 7.40624 2.9148C7.2001 2.63179 7.10801 2.28158 7.14825 1.93379C7.1885 1.58599 7.35815 1.26607 7.62348 1.03763C7.8888 0.809184 8.23038 0.688946 8.5803 0.700815C8.93021 0.712683 9.26285 0.855789 9.51209 1.10168C10.922 2.49811 11.5256 3.10397 12.9198 4.5094C13.1587 4.75338 13.2985 5.07733 13.3123 5.41852C13.326 5.75971 13.2126 6.09386 12.9941 6.35625Z"
                    fill="#A6AAB4" />
                </g>
                <defs>
                  <clipPath id="clip0_220_194">
                    <rect width="14" height="14" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>

            <div class="customer-timeline-pinned-event__close" @click="$emit('close')">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <g clip-path="url(#clip0_101_7908)">
                  <path
                    d="M16.364 14.1266L12.2373 10L16.364 5.87339C16.6607 5.5767 16.8273 5.1743 16.8273 4.75472C16.8273 4.33514 16.6607 3.93274 16.364 3.63606C16.0673 3.33937 15.6649 3.17269 15.2453 3.17269C14.8257 3.17269 14.4233 3.33937 14.1266 3.63606L10 7.76269L5.87337 3.63606C5.57668 3.33937 5.17428 3.17269 4.7547 3.17269C4.33512 3.17269 3.93273 3.33937 3.63604 3.63606C3.33935 3.93274 3.17267 4.33514 3.17267 4.75472C3.17267 5.1743 3.33935 5.5767 3.63604 5.87339L7.76267 10L3.63604 14.1266C3.33935 14.4233 3.17267 14.8257 3.17267 15.2453C3.17267 15.6649 3.33935 16.0673 3.63604 16.364C3.93272 16.6607 4.33512 16.8273 4.7547 16.8273C5.17428 16.8273 5.57668 16.6607 5.87337 16.364L10 12.2373L14.1266 16.364C14.4233 16.6607 14.8257 16.8273 15.2453 16.8273C15.6649 16.8273 16.0673 16.6607 16.364 16.364C16.6606 16.0673 16.8273 15.6649 16.8273 15.2453C16.8273 14.8257 16.6606 14.4233 16.364 14.1266Z"
                    fill="#A6AAB4" />
                </g>
                <defs>
                  <clipPath id="clip0_101_7908">
                    <rect width="20" height="20" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
        </div>

        <timeline-event-quotation :doctor_names="doctor_names" @edit="editEvent" @done="doneEvent" @note="noteEvent"
          @assign="assignEvent" :event='this.event' :entity="entity" v-if="event.entity == 'Quotation'">
        </timeline-event-quotation>

        <timeline-event-treatment :doctor_names="doctor_names" @edit="editEvent" @done="doneEvent" @note="noteEvent"
          @assign="assignEvent" :event='this.event' :entity="entity" v-else-if="event.entity == 'Treatment'">
        </timeline-event-treatment>

        <timeline-event-appointment :doctor_names="doctor_names" @edit="editEvent" @done="doneEvent" @note="noteEvent"
          @assign="assignEvent" :event='this.event' :entity="entity" v-else-if="event.entity == 'Appointment'">
        </timeline-event-appointment>

        <timeline-event-history-entry :doctor_names="doctor_names" @done="doneEvent" @note="noteEvent"
          @assign="assignEvent" :event='this.event' :entity="entity" v-else-if="event.entity == 'HistoryEntry'">
        </timeline-event-history-entry>

        <timeline-event-labwork @done="doneEvent" @edit="editEvent" @note="noteEvent" @assign="assignEvent"
          :event='this.event' :entity="entity" :doctor_names="doctor_names" @appointment="appointEvent"
          v-else-if="event.entity == 'LabWork'">
        </timeline-event-labwork>

        <div v-else>
          <strong>Entidad no reconocida. Avisar al Administrador</strong>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: ['clinic', 'event', 'entity', 'doctor_names', 'expanded'],
  computed: {
    is_pinned() {
      return this.event.pinned;
    },
    is_editable() {
      return this.event.entity == 'HistoryEntry';
    },
    event_subtitle() {
      switch (this.event.entity) {
        case 'HistoryEntry':
          return moment(this.event.date).format('DD/MM/YY');
        case 'Quotation':
          if (this.entity.notes !== null && this.entity.notes !== '') {
            return this.entity.notes;
          }
          return this.entity.code;
        case 'Treatment':
          return this.entity.full_name;
        case 'Appointment':
          return moment(this.event.date).format('DD/MM/YY - HH:mm');
      }
      return '';
    },
    event_title() {
      switch (this.event.entity) {
        case 'HistoryEntry':
          const title = this.entity.title;
          if (title && title !== '') {
            return title;
          }
          return 'Nota';
        case 'Quotation':
          switch (this.event.action) {
            case 'CREATED':
              return 'Plan Creado';
            case 'APPROVED':
              return 'Plan Aprobado';
          }
          break;
        case 'Treatment':
          switch (this.event.action) {
            case 'DONE':
              return 'Tratamiento Realizado';
          }
          break;
        case 'Appointment':
          switch (this.event.action) {
            case 'SCHEDULED':
              return 'Cita Programada';
            case 'DONE':
              return 'Cita Realizada';
            case 'FAILED':
              return 'Cita Fallida';
          }
          break;
      }
      return this.event.entity + ' ' + this.event.action;
    },
    event_detail_title() {
      switch (this.event.entity) {
        case 'HistoryEntry':
          return 'Nota';
        case 'Quotation':
          switch (this.event.action) {
            case 'CREATED':
              return 'Plan Creado';
            case 'APPROVED':
              return 'Plan Aprobado';
          }
          break;
        case 'Treatment':
          switch (this.event.action) {
            case 'DONE':
              return 'Tratamiento Realizado';
          }
          break;
        case 'Appointment':
          switch (this.event.action) {
            case 'SCHEDULED':
              return 'Cita Programada';
            case 'DONE':
              return 'Cita Realizada';
            case 'FAILED':
              return 'Cita Fallida';
          }
          break;
      }
      return this.event.entity + ' ' + this.event.action;
    },
    event_doctor() {
      if (this.entity && this.entity.doctor_id) {
        return this.doctor_names[this.entity.doctor_id] || '';
      }
      return '';
    },
    event_date() {
      if (this.event.entity == 'Appointment') {
        return moment(this.event.date).format('DD/MM/YY - HH:mm');
      }
      return window.WabiDent.fmtDate(this.event.date);
    },
  },
  methods: {
    pinEvent() {
      this.$emit('pin', this.event);
    },
    editEvent() {
      this.$emit('edit', this.event, this.entity);
    },
    doneEvent(event, treatment) {
      this.$emit('done', event, treatment);
    },
    noteEvent(event, treatment) {
      this.$emit('note', event, treatment);
    },
    assignEvent(event, treatment) {
      this.$emit('assign', event, treatment);
    }
  }
}
</script>

<style lang="scss">
.customer-timeline-pinned-event {
  border-radius: 10px;
  background: var(--ui-gris-oscuro, #EDEFF2);
  padding: 10px;
  margin: 10px 0 0 0;
  cursor: pointer;
  transition: opacity .3s;
  position: inherit;

  &__icon {
    flex: 0 0 20px;
    width: 20px;
    height: 20px;
    border-radius: 10px;
    background: var(--texto-gris, #A6AAB4);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 0 6px 6px 0;
  }

  &__title {
    font-size: 14px;
    font-weight: bold;
  }

  &.muted {
    opacity: 0.75;
  }

  &.expanded {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-bottom: 10px #EDEFF2 solid;
  }

  &__detail {
    left: 10px;
    width: calc(100% - 10px);
    position: absolute;
    border-radius: 10px;
    background: var(--ui-gris-oscuro, #EDEFF2);
    z-index: 10;
    padding: 10px 26px 26px 26px;
  }

  &__detail-title {
    font-size: 18px;
    font-weight: 700;
    color: var(--theme-text-color);
    text-decoration: none;
    transition: .3s;

    i {
      opacity: 0;
      transition: .3s;
      color: var(--theme-color);
      margin-left: 5px;
      font-size: 75%;
    }

    &:hover {
      color: var(--theme-text-color);
      text-decoration: none;
    }

    &.editable {
      cursor: pointer;

    }

    &.editable:hover {
      text-decoration: none;
      color: var(--theme-color);

      i {
        opacity: 1;
      }
    }
  }

  &__date,
  &__doctor {
    color: var(--texto-gris, #A6AAB4);
    font-size: 15px;
    font-weight: 500;
  }

  &__pin-icon {
    svg path {
      transition: .3s;
    }

    cursor: pointer;

    &.pinned svg path,
    &:hover svg path {
      fill: var(--theme-color);
    }
  }

  &__close {
    transition: .3s;
    cursor: pointer;

    &:hover svg path {
      fill: var(--theme-color);
    }
  }
}
</style>
